<div mat-dialog-content>
  <div class="text-center">
    <mat-icon>error_outline</mat-icon>
  </div>
  <h2 class="text-center">{{ 'deleteModal.title' | transloco }}</h2>
</div>
<div mat-dialog-actions class="px-5 py-3">
  <button class="cancel-button" mat-raised-button mat-dialog-close tabindex="-1">
    {{ 'deleteModal.cancel' | transloco }}
  </button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true" tabindex="-1">
    {{ 'deleteModal.confirm' | transloco }}
  </button>
</div>
